<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import Button from "@smui/button";
  import Spinner from "./Spinner.svelte";

  import { setToken, isLoggedIn, clearToken } from "./auth";
  import { apiPost, notify } from "./httpCommon";
  import { Textfield } from "./components";
  import Paper, { Title, Content } from "@smui/paper";

  let data = {};
  let errors = {};
  let submitting = false;

  async function doLogin() {
    errors = {};

    console.log(`data: ${data}`);

    if (!data.username) {
      errors.username = "Username required";
    }
    if (!data.password) {
      errors.password = "Password required";
    }

    console.log("errors", errors);

    if (!submitting && Object.keys(errors).length === 0) {
      submitting = true;
      try {
        const json = await apiPost("/login", data);
        if (json) {
          if (json.token) {
            setToken(json.token);
          }
        }
      } catch (err) {
        console.log("Login failed", err)
        data = {};
      } finally {
        submitting = false;
      }
      console.log("isLoggedIn",isLoggedIn())
      if (isLoggedIn()) {
        navigate("/");
      }
    }
  }

  onMount(() => {
    if (isLoggedIn()) {
      navigate("/");
    } else {
      clearToken();
    }
  });
</script>

<style>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .login-container {
    width: 300px;
    text-align: center;
    padding: 24px;
  }

  .action-container {
    margin-top: 32px;
  }
</style>

<main class="container">
  <Paper elevation={5}>
    <Title class="centre">Fooddisco Admin</Title>
    <Content>
      <div class="login-container">
        <form on:submit|preventDefault={doLogin}>
          <Textfield
            class="stretch"
            variant="outlined"
            label="Username"
            bind:value={data.username}
            error={errors.username} />
          <Textfield
            class="stretch"
            variant="outlined"
            type="password"
            label="Password"
            bind:value={data.password}
            error={errors.password} />
          <div class="action-container">
            <Button type="submit" variant="raised" disabled={submitting}>
              {#if submitting}
                <Spinner />
              {:else}Login{/if}
            </Button>
          </div>
        </form>
      </div>
    </Content>
  </Paper>
</main>
